/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Start_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Start project import" |
*
* @param {Team_Project_Import_Start_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_start_aria_label = /** @type {((inputs?: Team_Project_Import_Start_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Start_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrer l’importation du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektimport starten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvia l'importazione del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начать импорт проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar la importación del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始项目导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのインポートを開始")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट आयात शुरू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciar importação de projeto")
	return /** @type {LocalizedString} */ ("Start project import")
});